(function() {
    'use strict';

    angular
        .module('elogbooks.common.jobs')
        .controller('CommonJobDetailsRequisitesController', CommonJobDetailsRequisitesController);

    CommonJobDetailsRequisitesController.$inject = ['jobRequisiteEventsResponse', 'elbFileModalService'];

    function CommonJobDetailsRequisitesController(jobRequisiteEventsResponse, elbFileModalService) {
        var vm = this;
        vm.jobRequisiteEventsResponse = jobRequisiteEventsResponse;
        vm.jobRequisiteEventsResponse['job-requisites-answers'].forEach(function(elem) {
            if(elem.hasOwnProperty('files')) {
                elem.answer = "ATTACHED_FILES";
            } else if (elem.notApplicable) {
                elem.answer = "ANSWERED_NA";
            } else if (elem.answeredYes) {
                elem.answer = "ANSWERED_YES";
            } else {
                elem.answer = "ANSWERED_NA";
            }

            getCafmIcon(elem);
            getSpApprovalCafmIcon(elem);
            getApproverApprovalCafmIcon(elem);
        });

        function getCafmIcon(jobRequisiteAnswer) {
            jobRequisiteAnswer.icon = 'pace';
            jobRequisiteAnswer.iconClass = 'text-info';
            if (jobRequisiteAnswer.answeredYes || jobRequisiteAnswer.notApplicable) {
                jobRequisiteAnswer.icon = 'feedback';
                jobRequisiteAnswer.iconClass = 'text-primary';
            }
        }

        function getSpApprovalCafmIcon(jobRequisiteAnswer) {
            if (
                (jobRequisiteAnswer.approvalStrategy == 3 || jobRequisiteAnswer.approvalStrategy == 2) &&
                (jobRequisiteAnswer.serviceProviderApproved && (jobRequisiteAnswer.answeredYes || jobRequisiteAnswer.notApplicable))
            ) {
                jobRequisiteAnswer.spApprovalIcon = 'check';
                jobRequisiteAnswer.spApprovalIconClass = 'text-primary';
            } else if (
                (jobRequisiteAnswer.approvalStrategy == 3 || jobRequisiteAnswer.approvalStrategy == 2) &&
                jobRequisiteAnswer.approvalSequence < 0 && !jobRequisiteAnswer.serviceProviderApproved
            ) {
                jobRequisiteAnswer.spApprovalIcon = 'close';
                jobRequisiteAnswer.spApprovalIconClass = 'text-danger';
            }
        }

        function getApproverApprovalCafmIcon(jobRequisiteAnswer) {
            if (
                jobRequisiteAnswer.approvalStrategy > 0 && jobRequisiteAnswer.approverApproved
            ) {
                jobRequisiteAnswer.approverApprovalIcon = 'check';
                jobRequisiteAnswer.approverApprovalIconClass = 'text-primary';
            } else if (
                jobRequisiteAnswer.approvalStrategy > 0 &&
                jobRequisiteAnswer.approvalSequence == -1 &&
                (
                    (jobRequisiteAnswer.serviceProviderApproved && jobRequisiteAnswer.approvalStrategy === 2) ||
                    jobRequisiteAnswer.approvalStrategy === 1
                ) &&
                !jobRequisiteAnswer.approverApproved &&
                (jobRequisiteAnswer.answeredYes || jobRequisiteAnswer.notApplicable)
            ) {
                jobRequisiteAnswer.approverApprovalIcon = 'close';
                jobRequisiteAnswer.approverApprovalIconClass = 'text-danger';
            }
        }

        vm.showAction = function (file) {
            file.tags = [];
            return elbFileModalService.open(file, []);
        };
    }
})();
